import { Injectable } from '@angular/core';
import { CanDeactivate } from '@angular/router';
import {ComponentCanDeactivate} from './component-can-deactivate';
import { TranslateService } from '@ngx-translate/core';

@Injectable()
export class CanDeactivateGuard implements CanDeactivate<ComponentCanDeactivate> {
  
   canDeactivate(component: ComponentCanDeactivate): boolean {
      if(!component.canDeactivate()){
        if (confirm(component.translate.instant('CONFIRM_UNSAVED'))) {
            return true;
        } else {
            return false;
        }
    }
    return true;
  }


}
